import { ApiRequest } from "src/models/api.request";
import ServisVeriSil from "src/models/Settings/Generals/ServisVeriSil";
import VwHbsBransDTO from "src/models/Settings/Generals/VwHbsBransDTO";
import VwHbsServisveriDTO from "src/models/Settings/Generals/VwHbsServisveriDTO";
import api from "src/services/core/api";

const controllerName = "VwHbsBransDTO";
export const bransTanimApi = api.injectEndpoints({
  endpoints: builder => ({
    bransGetAll: builder.query<Array<VwHbsBransDTO>, void>({
      query: () => {
        const request: ApiRequest<VwHbsBransDTO> = {
          sorts: [{ fieldName: "adi" }]
        }
        return {
          url: controllerName + "/find",
          method: "POST",
          body: JSON.stringify(request)
        }
      },
      providesTags: ["BransTanim"]
    }),
    bransCreate: builder.mutation<VwHbsBransDTO, VwHbsBransDTO>({
      query: (request) => ({
        url: controllerName,
        method: "POST",
        body: request
      }),
      invalidatesTags: ["BransTanim"]
    }),
    bransUpdate: builder.mutation<VwHbsBransDTO, VwHbsBransDTO>({
      query: (request) => ({
        url: controllerName,
        method: "PUT",
        body: request
      }),
      invalidatesTags: ["BransTanim"]
    }),
    bransDelete: builder.mutation<boolean, number>({
      query: (id) => ({
        url: controllerName + "/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["BransTanim"]
    }),
    getHbsServisveri: builder.query<Array<VwHbsServisveriDTO>, {
      bransId: number,
      tip: Array<number>
    }>({
      query: (request) => {
        let req: ApiRequest<VwHbsServisveriDTO> = {
          paging: false,
          filters: {
            groupOperator: "and",
            predicates: [
              { fieldName: "bransId", operator: "=", value1: request.bransId },
              { fieldName: "tip", operator: "in", value1: request.tip }
            ]
          },
          sorts: [{ fieldName: "sira" }]
        }
        return {
          url: "VwHbsServisveriDTO/find",
          method: "POST",
          body: JSON.stringify(req)
        }
      },
      providesTags: ["ServisVeri"]
    }),
    ServisVeriKayitEkleGuncelle: builder.mutation<VwHbsServisveriDTO, VwHbsServisveriDTO>({
      query: (request) => {
        return {
          url: "ServisVeri/ServisVeriKayitEkleGuncelle",
          method: "PUT",
          body: JSON.stringify(request)
        }
      },
      invalidatesTags: ["ServisVeri"],
    }),
    HbsServisVeriSil: builder.mutation<boolean, ServisVeriSil>({
      query: (request) => {
        return {
          url: "ServisVeri/ServisVeriKayitSil",
          method: "DELETE",
          body: JSON.stringify(request)
        }
      },
      invalidatesTags: ["ServisVeri"],
    }),
  }),
})

export const {
  useBransGetAllQuery,
  useBransCreateMutation,
  useBransUpdateMutation,
  useBransDeleteMutation,
  useGetHbsServisveriQuery,
  useServisVeriKayitEkleGuncelleMutation,
  useHbsServisVeriSilMutation,
} = bransTanimApi;